import Constants from '@intercom/embercom-composer/lib/constants';
import zeroWidthSpaces from '@intercom/embercom-composer/lib/zero-width-spaces';
import $ from 'jquery';
import { cancel, next, scheduleOnce } from '@ember/runloop';
import Em from 'ember';
export default Em.Mixin.create({
  syncAndUpdateDomAndSelection() {
    this.syncCurrentBlock();
    this.updateDomAndSelection();
  },
  markCurrentBlockAsSynced() {
    let block = this.getCurrentBlock(true);
    if (block) {
      let html = block.html();
      if (html) {
        let blockId = block.data('id');
        this.set('markAsSyncedTimer', scheduleOnce('actions', this, this._markCurrentBlockAsSynced, blockId, html));
      } else {
        // This means we have tried to mark as synced but have not found a block due to the browser being in a weird selection state
        // Cancel any other syncs on this run loop and leave the sync state alone
        cancel(this.get('markAsSyncedTimer'));
      }
    }
  },
  _markCurrentBlockAsSynced(blockId, html) {
    if (this.isDestroying) {
      return;
    }
    html = html.replace(Constants.ZERO_WIDTH_SPACE_GLOBAL_REGEX, '');
    this.setProperties({
      lastSyncedBlockId: blockId,
      lastSyncedHtml: html
    });
  },
  setLastActiveBlockAndSelection() {
    let currentBlock = this.getCurrentBlock(true);
    if (currentBlock) {
      this.setProperties({
        lastActiveBlockId: currentBlock.data('id'),
        lastActiveSelection: this.getUiSelection()
      });
    } else {
      this.setProperties({
        lastActiveBlockId: null,
        lastActiveSelection: null
      });
    }
  },
  updateDomAndSelection() {
    this.setProperties({
      lastSyncedBlockId: null,
      lastSyncedHtml: null
    });
    try {
      this.updateDom();
      this.updateUISelection();
    } catch (error) {
      this.sendError(error);
    }
  },
  updateDom() {
    try {
      if (this.get('isDestroying')) {
        return;
      }
      this.get('composerRenderer').render(this.get('composerState.html'));
      if (this.get('composerState.selection.isSingleUneditableBlock')) {
        this.addSelectionBorderToCurrentBlock();
      }
      zeroWidthSpaces(this.get('$editor')[0]);
      this.markCurrentBlockAsSynced();
      next(this, function () {
        this.setEditorDimensions();
      });
      this.trigger('render');
    } catch (error) {
      this.sendError(error);
    }
  },
  updateUISelection() {
    try {
      if (this.get('isDestroying')) {
        return;
      }
      let $editor = this.get('$editor');
      this.get('uiSelection').updateSelection(this.get('composerState.selection'), this.get('$editor'));
      if ($editor) {
        $editor.focus();
      }
      this.setSelectionCoordinates();
      this.setTextBeforeCursor();
    } catch (error) {
      this.sendError(error);
    }
  },
  syncCurrentBlockIfNoRedoStack() {
    if (this.get('composerState.hasNoRedoStack')) {
      this.syncCurrentBlockAndCheckpoint();
    }
  },
  syncCurrentBlockAndCheckpoint() {
    this.syncCurrentBlock(true);
  },
  syncCurrentBlockWithoutSelectionUpdate() {
    this.syncCurrentBlock(true, false);
  },
  lastSyncedHtml: null,
  syncCurrentBlock(shouldCheckpoint, updateSelection) {
    updateSelection = updateSelection === undefined ? true : updateSelection;
    let currentBlock = this.getCurrentBlock(true);
    let selection = this.getUiSelection();
    if (currentBlock && currentBlock.length && selection) {
      this._syncBlock(currentBlock, selection, shouldCheckpoint, updateSelection);
    }
  },
  syncLastActiveBlock() {
    let html;
    let lastActiveBlockId = this.get('lastActiveBlockId');
    let commandResult;
    if (lastActiveBlockId) {
      let selection = this.get('lastActiveSelection');
      let $lastActiveBlock = $(`[data-id="${lastActiveBlockId}"]`, this.element);
      if ($lastActiveBlock && $lastActiveBlock.length && selection) {
        html = $lastActiveBlock.html().replace(Constants.ZERO_WIDTH_SPACE_GLOBAL_REGEX, '');
        commandResult = this.get('composerState').syncWithoutCheckpoint(html, selection);
        if (commandResult.get('shouldRerender')) {
          this.updateDomAndSelection();
        }
      }
    }
  },
  _syncBlock(block, selection, shouldCheckpoint, updateSelection) {
    try {
      let blockId = block.data('id');
      let html = block.html().replace(Constants.ZERO_WIDTH_SPACE_GLOBAL_REGEX, '');
      if (html !== this.get('lastSyncedHtml') || blockId !== this.get('lastSyncedBlockId')) {
        let commandResult;
        if (shouldCheckpoint) {
          commandResult = this.get('composerState').sync(html, selection);
        } else {
          commandResult = this.get('composerState').syncWithoutCheckpoint(html, selection);
        }
        if (commandResult.get('shouldRerender')) {
          if (updateSelection) {
            this.updateDomAndSelection();
          } else {
            this.updateDom();
          }
        } else {
          this.trigger('syncWithoutRender');
        }
        if (commandResult.get('didSync')) {
          this.markCurrentBlockAsSynced();
        }
      } else {
        //TODO: GJ: write an integration test which covers this
        //eslint-disable-next-line no-lonely-if
        if (updateSelection) {
          this.get('composerState').setSelection(
          //NOTE: GJ: refactor how we set selection from ui->composer state
          selection.startBlockIndex, selection.startItemIndex, selection.startPositionIndex, selection.endBlockIndex, selection.endItemIndex, selection.endPositionIndex);
        }
      }
    } catch (error) {
      this.sendError(error);
    }
  }
});